import { TabStrip, TabStripSelectEventArguments } from "@progress/kendo-react-layout";
import { useEffect, useState } from "react";
import { checkTimesheetStatus, makeSideBarActive } from "../../utils/ellowutils";
import SideMenu from "../sideMenu";
import DashboardHeader from "../topbar";
import * as CONSTANTS from "../../utils/CONSTANTS";
import Styles from "./styles.module.scss";
import { useLocation } from "react-router-dom";
import TimeSheetHistoryTab from "./timeSheetHistory";
import { getTimeSheetDetails , approveTimeSheet , rejectTimeSheet , getHistory } from "./service";
import NotificationAlert from '../../compopnents/notification';
import ConfirmationModal from '../../modal/confirmation/confirmationModal';
import { postAPI } from "../../api";
import { REACT_APP_CANDIDATE_FREELANCER } from "../../utils/common";
import mixpanelData from "../../utils/mixpanel";
  

function TimeSheetHistory() {

    const location = useLocation();
    const { candidateJobId }: any = location.state || ''
    const { jobTitle }: any = location.state || ''
    const { candidateName } :any = location.state || ''  
    const { position }: any = location.state || ''
    const { projectId }: any = location.state || ''
    const { timesheetId}: any = location.state || '' 
    const { candidateData }: any = location.state || '' 

    const BreadcrumsValues = [position];
    const menu = makeSideBarActive(CONSTANTS.sideMenu, 2);

    const [selected, setSelected] = useState<number>(0);
    const [timesheetEntries , setTimesheetEntries] = useState<any>()
    const [timesheetDetails , setTimesheetDetails] = useState<any>() 
    const [timesheet_id , setTimesheet_id] = useState<any>()
    const [manager_email , setManager_emai] = useState<any>()
    const [notification, setNotification] = useState<boolean>(false)
    const [message, setMessage] = useState<string>('')
    const [modal, setModal] = useState<boolean>(false)
    const [historyData, setHistoryData] = useState<any>()
    const [timesheetStatus, setTimesheetStatus] = useState<any>()
    const [disable, setDisable] = useState<boolean>(false)
    const [disableModalbtn, setDisableModalbtn] = useState<boolean>(false)

    const handleSelect = (e: TabStripSelectEventArguments) => {
      setSelected(e.selected);
    };
  
    useEffect(() => {
        
        getTimeSheetDetals()
        getHistoryDetails (timesheetId)
        
    },[])

    const  getTimeSheetDetals = () => {
        getTimeSheetDetails(timesheetId, projectId).then((response) => {
            if(response && response.status === 1){
                setTimesheetEntries(response.data[0].timesheetEntries)
                setTimesheetDetails(response.data[0].timesheetDetails[0])
                setTimesheet_id(response.data[0].timesheetDetails[0].timesheet_id)
                setManager_emai(response.data[0].timesheetDetails[0].manager_email)
                mixpanelData('New MT - Timesheet viewed', {
                    // 'Distinct id': localStorage.getItem('loginId'),
                    'Candidate email': response && response.data[0].candidateDetails[0].email,
                    'Candidate name': response && response.data[0].candidateDetails[0].candidateName,
                    'Position name': position,
                    'Company name': response && response.data[0].projectDetails[0].companyName,
                    'Pay period start date': response && response.data[0].timesheetDetails[0].start_date && new Date(parseInt(response.data[0].timesheetDetails[0].start_date)).toDateString(),
                    'Pay period end date': response && response.data[0].timesheetDetails[0].end_date && new Date(parseInt(response.data[0].timesheetDetails[0].end_date)).toDateString(),
                    'Status': checkTimesheetStatus(response && response.data[0].timesheetDetails[0].timesheet_status).value
                })
            }
        })
    }

    const getHistoryDetails = (timesheetId: string) => {
        getHistory(timesheetId).then((response) => {
          if (response && response.status === 1) {
            setHistoryData(response.data)               
            let length = response.data && response.data.length
            setTimesheetStatus(response.data[length - 1].status_id)
           
          }
        })
      }

    const submitApproveTimeSheet = () => {
        setDisable(true)
        let value = {
            "timesheetId": timesheet_id,
            "reportingManagerEmail": manager_email
        }
        approveTimeSheet(value).then((response) => {
            if(response && response.status === 1){
                setDisable(false)
                displayNotification("Time sheet approved successfully")
                mixpanelData('New MT - Timesheet approved', {
                    'distinct_id': localStorage.getItem('Email'),
                    'Candidate email': response && response.data[0].email,
                    'Candidate name': response && response.data[0].candidateName,
                    'Position name': response && response.data[0].position,
                    'Company name': response && response.data[0].companyName,
                    'Pay period start date': response && response.data[0].startDate && new Date(parseInt(response.data[0].startDate)).toDateString(),
                    'Pay period end date': response && response.data[0].endDate && new Date(parseInt(response.data[0].endDate)).toDateString(),
                    'Verified by': response && response.data[0].verifiedBy
                })
                getTimeSheetDetals();
            }
        }) 
    }

    const submitRejectTimeSheet = (data: any) =>{
        setDisable(true)
        let value = {
            "timesheetId": timesheet_id,
            "reportingManagerEmail": manager_email,
            "rejectComment": data.rejectComment
        }  
        rejectTimeSheet(value).then((response) => {
            if(response && response.status === 1){
                setDisableModalbtn(false)
                setDisableModalbtn(false)
                displayNotification("Time sheet rejected successfully")
                mixpanelData('New MT - Timesheet rejected', {
                    'distinct_id': localStorage.getItem('Email'),
                    'Candidate email': response && response.data[0].email,
                    'Candidate name': response && response.data[0].candidateName,
                    'Position name': response && response.data[0].position,
                    'Company name': response && response.data[0].companyName,
                    'Pay period start date': response && response.data[0].startDate && new Date(parseInt(response.data[0].startDate)).toDateString(),
                    'Pay period end date': response && response.data[0].endDate && new Date(parseInt(response.data[0].endDate)).toDateString(),
                    'Verified by': response && response.data[0].verifiedBy
                })
            }
        }) 
    }

    const setModalTrue = () => {
        setModal(true)
    }

    const displayNotification = (message: string) => {
        setMessage(message)
        setNotification(true)
        setTimeout(() => {
          setNotification(false)
        }, 3000)  
    }

    const downloadTimesheet = () => {
        let value = {
          "action": "getObject",
          "filename": `timesheetUploads/${timesheet_id}.pdf`,
          "bucketName": "ellow-prod-doc-upload",
        };
        
        postAPI(REACT_APP_CANDIDATE_FREELANCER + '/api/v1/tg/resume-signed-url', value).then((data) => {
          let signedUrl = data.url;
          downloadHandle(signedUrl, candidateName, 'project', timesheetDetails && timesheetDetails.start_date && parseInt(timesheetDetails.start_date))
        })
    }
    
    const downloadHandle=(url:any, name: string, projectName: string, startDate: number)=>{     
         
        const monthNumber = new Date(startDate).getMonth()
        const months = ["January","February","March","April","May","June","July","August","September","October","November","December"];
        let presentMonth = months[monthNumber]
    
        fetch(url).then(response => {
            
          response.blob().then(blob => {
              const fileURL = window.URL.createObjectURL(blob);
              let alink = document.createElement('a');
              alink.href = fileURL;
              alink.download =`${name}-${projectName}-${presentMonth}.pdf`;
              alink.click();
          })
      })
      }
  
    return (
        <section className="dashboardWrapper full">
            <div className="dashboardContent">
                <DashboardHeader
                    title={false}
                    searchChange={false}
                    type=' '
                    name={candidateName}
                    NoSettingsIcon={true}
                    timesheetStatus={candidateData.timesheetStatus}
                    role={candidateData.position}
                    companyName={candidateData.companyName}
                />
            <section className={Styles.timeSheetWrapper}>
            <div>
                <TimeSheetHistoryTab timesheetEntries={timesheetEntries} downloadButton={downloadTimesheet} timesheetDetails={timesheetDetails} clickHandler={submitApproveTimeSheet} setModalTrue={setModalTrue} historyData={historyData} timesheet_status={timesheetStatus} disable={disable}/>
            </div>
            </section>
            {notification && <NotificationAlert onClose={() => setNotification(false)} closable={true}>{message}</NotificationAlert>}
            {modal && <ConfirmationModal onClose={ () => setModal(false)} submit={submitRejectTimeSheet} reject={true} disable={disableModalbtn}/>}
            </div>
        </section>
    )
  }
export default TimeSheetHistory;
  